import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { libraryShape } from '@bibliocommons/bc-prop-types';

import { selectCurrentLibrary, selectLibraryLinkedData } from 'app/selectors/LibrarySelector';
import { selectAppConfig } from 'app/selectors/AppSelector';
import { libraryLinkedDataShape, linkedDataShape } from 'app/shapes/document';
import DocumentHead from './DocumentHead';

export class DocumentHeadContainer extends React.PureComponent {
  render() {
    return <DocumentHead {...this.props} />;
  }
}

DocumentHeadContainer.defaultProps = {
  excludeLibraryFromMetaTitle: false
};

DocumentHeadContainer.propTypes = {
  // ownProps
  excludeLibraryFromMetaTitle: PropTypes.bool,
  pageTitle: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  linkedData: linkedDataShape,
  noIndex: PropTypes.bool,
  pageUrl: PropTypes.string,

  // Redux props
  appVersion: PropTypes.string,
  currentLibrary: libraryShape.isRequired,
  libraryLinkedData: libraryLinkedDataShape.isRequired,
  twitterUrl: PropTypes.string,
  ogType: PropTypes.string
};

const mapStateToProps = state => {
  const appConfig = selectAppConfig(state);

  return {
    currentLibrary: selectCurrentLibrary(state),
    libraryLinkedData: selectLibraryLinkedData(state),
    appVersion: appConfig.get('appVersion')
  };
};

export default connect(mapStateToProps)(DocumentHeadContainer);
